import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './App.css';
import Header        from './components/Header';
import NavBar        from './components/NavBar';
import ProductSection from './components/ProductSection';
import FormProducto  from './components/FormProducto';
import CarritoFlotante from './components/CarritoFlotante';
import Login         from './components/Login';
import AdminPage     from './components/AdminPage';
import AdminCategoria from './components/AdminCategoria';
import AdminVentas   from './components/AdminVentas';
import Register      from './components/Register';
import ContactForm   from './components/ContactForm';
import EstadisticasPage from './components/EstadisticasPage';
import CategoriaPage from './components/CategoriaPage';
import ProductCard   from './components/ProductCard';
import PagoExitoso   from './components/PagoExitoso';
import PagoFallido   from './components/PagoFallido';
import MisCompras    from './components/MisCompras';
import MisDirecciones from './components/MisDirecciones';
import MiPerfil      from './components/MiPerfil';
import QuienesSomosPage from './components/QuienesSomosPage';
import MisionVisionPage from './components/MisionVisionPage';

import {
  fetchCategorias,
  fetchProductos,
  insertProducto,
  buscarProducto,
  checkout,
} from './services/api';

function PrivateRoute({ children, roleRequired }) {
  const token = localStorage.getItem("token");
  const role  = localStorage.getItem("role");
  if (!token) return <Navigate to="/login" />;
  if (roleRequired && role !== roleRequired) return <Navigate to="/" />;
  return children;
}

function App() {
  const [productos,  setProductos]  = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [detalleVenta, setDetalleVenta] = useState([]);
  const [modalProductoVisible, setModalProductoVisible] = useState(false);
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(detalleVenta));
  }, [detalleVenta]);

  useEffect(() => {
    cargarDatos();
    const carritoGuardado = localStorage.getItem('carrito');
    if (carritoGuardado) setDetalleVenta(JSON.parse(carritoGuardado));
  }, []);

  const cargarDatos = async () => {
    try {
      const catRes = await fetchCategorias();
      setCategorias(catRes.data);
    } catch (e) {
      console.error("Error cargando categorías:", e);
    }
    try {
      const prodRes = await fetchProductos();
      setProductos(prodRes.data);
    } catch (e) {
      console.error("Error cargando productos:", e);
    }
  };

  const handleAddProducto = async (producto) => {
    await insertProducto(producto);
    const res = await fetchProductos();
    setProductos(res.data);
  };

  const handleAgregarAlCarrito = (productoId, cantidad) => {
    const producto = productos.find(p => p.id === parseInt(productoId));
    if (!producto) return;
    const cantidadNum = parseFloat(cantidad);
    if (cantidadNum <= 0 || cantidadNum > producto.stock) {
      alert("Cantidad inválida o insuficiente stock");
      return;
    }
    const nuevoItem = {
      productoId: producto.id,
      nombre:     producto.nombre,
      cantidad:   cantidadNum,
      precio:     producto.precio,
      subtotal:   cantidadNum * parseFloat(producto.precio),
    };
    setDetalleVenta(prev => [...prev, nuevoItem]);
  };

  const calcularTotal = () =>
    detalleVenta.reduce((acc, item) => acc + item.subtotal, 0).toFixed(2);

  const handlePagar = async (datosEnvio) => {
    if (detalleVenta.length === 0) return alert("Agrega productos al carrito");
    try {
      const items        = detalleVenta.map(i => ({ productoId: i.productoId, cantidad: i.cantidad }));
      const totalConIVA  = Math.round(parseFloat(calcularTotal()) * 1.19);
      const res          = await checkout(items, totalConIVA, datosEnvio);
      const { ventaId, sandboxInitPoint, initPoint } = res.data;

      localStorage.setItem("ventaId", ventaId);
      setDetalleVenta([]);

      // En desarrollo usa sandboxInitPoint; en producción usa initPoint
      window.location.href = sandboxInitPoint || initPoint;
    } catch (err) {
      const msg = err.response?.data?.error || "Error al procesar el pago";
      alert(msg);
    }
  };

  const handleActualizarItem = (index, nuevaCantidad) => {
    setDetalleVenta(prev => {
      const copia = [...prev];
      const item  = copia[index];
      const prod  = productos.find(p => p.id === item.productoId);
      if (!prod || nuevaCantidad > prod.stock) {
        alert("Cantidad inválida o insuficiente stock");
        return prev;
      }
      item.cantidad = nuevaCantidad;
      item.subtotal = nuevaCantidad * parseFloat(item.precio);
      return copia;
    });
  };

  const handleEliminarItem = (index) =>
    setDetalleVenta(prev => prev.filter((_, i) => i !== index));

  const handleBuscarProducto = async (termino) => {
    if (!termino.trim()) return setResultadosBusqueda([]);
    try {
      const res = await buscarProducto(termino);
      setResultadosBusqueda(res.data);
    } catch {
      alert('Error al buscar productos');
    }
  };

  return (
    <Router>
      <div className="App">
        <Header
          setResultadosBusqueda={setResultadosBusqueda}
          onBuscar={handleBuscarProducto}
        />
        <NavBar onAgregar={handleAgregarAlCarrito} />

        <main>
          {modalProductoVisible && (
            <div style={{
              position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
              justifyContent: 'center', alignItems: 'center', zIndex: 1000
            }}>
              <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: 8 }}>
                <h3>Agregar Nuevo Producto</h3>
                <FormProducto
                  onSave={(p) => { handleAddProducto(p); setModalProductoVisible(false); }}
                  onCancel={() => setModalProductoVisible(false)}
                />
              </div>
            </div>
          )}

          {/* Resultados de búsqueda — se muestran encima de todo cuando hay resultados */}
          {resultadosBusqueda.length > 0 && (
            <div style={{ padding: "16px 24px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <h2 style={{ margin: 0 }}>🔍 Resultados de búsqueda ({resultadosBusqueda.length})</h2>
                <button
                  onClick={() => setResultadosBusqueda([])}
                  style={{ padding: "6px 14px", cursor: "pointer", border: "1px solid #ccc", borderRadius: 4, background: "#f5f5f5" }}
                >
                  ✕ Limpiar búsqueda
                </button>
              </div>
              <div className="product-grid">
                {resultadosBusqueda.map(p => (
                  <ProductCard
                    key={p.id}
                    idProduct={p.id}
                    name={p.nombre}
                    description={p.descripcion}
                    price={p.precio}
                    image={p.imagen}
                    especificacion={p.especificacion}
                    onAgregar={handleAgregarAlCarrito}
                  />
                ))}
              </div>
            </div>
          )}

          <Routes>
            <Route path="/register"       element={<Register />} />
            <Route path="/login"          element={<Login />} />
            <Route path="/contacto"       element={<ContactForm />} />
            <Route path="/quienes-somos"  element={<QuienesSomosPage />} />
            <Route path="/mision-vision"  element={<MisionVisionPage />} />
            <Route path="/pago/exitoso"  element={<PagoExitoso />} />
            <Route path="/pago/fallido"  element={<PagoFallido />} />
            <Route path="/pago/pendiente" element={<PagoFallido />} />

            <Route path="/admin" element={
              <PrivateRoute roleRequired="ADMIN"><AdminPage /></PrivateRoute>
            }/>
            <Route path="/categorias/nueva" element={
              <PrivateRoute roleRequired="ADMIN"><AdminCategoria /></PrivateRoute>
            }/>
            <Route path="/estadisticas" element={
              <PrivateRoute roleRequired="ADMIN"><EstadisticasPage /></PrivateRoute>
            }/>
            <Route path="/historial-venta" element={
              <PrivateRoute roleRequired="ADMIN"><AdminVentas /></PrivateRoute>
            }/>
            <Route path="/mi-perfil" element={
              <PrivateRoute roleRequired="CLIENT"><MiPerfil /></PrivateRoute>
            }/>
            <Route path="/mis-compras" element={
              <PrivateRoute roleRequired="CLIENT"><MisCompras /></PrivateRoute>
            }/>
            <Route path="/mis-direcciones" element={
              <PrivateRoute roleRequired="CLIENT"><MisDirecciones /></PrivateRoute>
            }/>

            <Route path="/" element={
              <>
                <h2>PRODUCTOS DISPONIBLES</h2>
                {categorias.map(categoria => (
                  <ProductSection
                    key={categoria.id}
                    title={categoria.nombre.toUpperCase()}
                    productos={productos}
                    onAgregar={handleAgregarAlCarrito}
                  />
                ))}
              </>
            }/>

            {categorias.map(categoria => (
              <Route
                key={categoria.id}
                path={`/categoria/${categoria.id}`}
                element={
                  <CategoriaPage
                    categoria={categoria.nombre}
                    productos={productos}
                    onAgregar={handleAgregarAlCarrito}
                  />
                }
              />
            ))}
          </Routes>
        </main>

        <CarritoFlotante
          detalleVenta={detalleVenta}
          total={calcularTotal()}
          onPagar={handlePagar}
          onActualizarItem={handleActualizarItem}
          onEliminarItem={handleEliminarItem}
        />
      </div>
    </Router>
  );
}

export default App;
